import React, { Component } from 'react';
import { connect, Provider } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import 'antd/dist/antd.css';
import DevTools from '~/DevTools';

// Action
import { ProfileAction } from '~/actions';

// Page
import PublicLayout from '~/components/Layout/PublicLayout';
import LoadingPage from '~/components/LoadingPage';
import PressureGraph from './PressureGraph';
import PressureSimulation from './PressureSimulation';
import SeismicEvent from './SeismicEvent';
import SeismicWave from './SeismicWave';
import Error404 from './Error404';
import Rain from './Rain';
import SeepageSimulation from './SeepageSimulation';
import SeepageGraph from './SeepageGraph';
import WaterStorage from './WaterStorage';

import '../../fonts/Quark/quark.css';

const isProd = process.env.NODE_ENV === 'production';

class App extends Component {
  UNSAFE_componentWillMount() {
    const { loadSession } = this.props;
    loadSession();
  }

  render() {
    const {
      store,
      profile,
      profile: {
        hasLoaded,
        seismic: { enable: seismicEnable },
        pressure: {
          enable: pressureEnable,
          waterStorage: { enable: storageEnable },
        },
        seepage: { enable: seepageEnable },
        seepage_v2: { enable: seepageV2Enable },
        rain: { enable: rainEnable },
      },
      webConfig,
    } = this.props;
    return (
      <Provider store={store}>
        <PublicLayout {...profile} damList={webConfig.damList}>
          <Helmet titleTemplate={`โครงการ${profile.site_name} | %s`}>
            <title>Welcome to Dam monitoring</title>
          </Helmet>

          <Switch>
            {pressureEnable && <Route exact path="/" component={PressureSimulation} />}
            {seepageEnable && (
              <Route path="/pressure/seepage/:time?" component={SeepageSimulation} />
            )}
            {seepageV2Enable && (
              <Route path="/pressure/seepage-v2/:time?" component={SeepageGraph} />
            )}
            {seismicEnable && <Route exect path="/seismic/event" component={SeismicEvent} />}
            {seismicEnable && (
              <Route
                path="/seismic/station/:station?/m/:time?"
                render={(props) => <SeismicWave {...props} shouldPin={true} />}
              />
            )}
            {seismicEnable && (
              <Route path="/seismic/station/:station?/:time?" component={SeismicWave} />
            )}
            {rainEnable && <Route path="/rain/history/:time?" component={Rain} />}
            {pressureEnable && <Route path="/pressure/history" component={PressureGraph} />}
            {storageEnable && <Route path="/water/storage/:year?" component={WaterStorage} />}
            <Route path="/:any" component={hasLoaded ? Error404 : LoadingPage} />
          </Switch>

          {!isProd && <DevTools />}
        </PublicLayout>
      </Provider>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      profile: state.DamProfile,
      webConfig: state.WebConfig,
    }),
    {
      loadSession: ProfileAction.loadSession,
    },
  )(App),
);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/App.js